import { render, staticRenderFns } from "./AusterSelect.vue?vue&type=template&id=17063d93&"
import script from "./AusterSelect.vue?vue&type=script&lang=ts&"
export * from "./AusterSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AusterSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports